<template>
  <div class="login-pane">
    <header class="header">
      <span class="big">国家税务总局XXX电子税务局</span>
      |
      <span class="tong">统一身份认证</span>

      <div class="grow"></div>

      <span class="bt">旧版登录</span>

      <span class="bt">返回首页</span>
    </header>

    <main class="main-box">
      <div class="pane" @click="exeLogin"></div>
    </main>

    <footer class="foot">
      <img src="https://static.rhkj.com/renhe_fe/other/322.png"/>
    </footer>

  </div>
</template>

<script setup>
import {setLoginInfo} from "@/views/examCenter/taxDigitalAccountV2/taxDigAccLoginHandler.js";
import {setReportTaxLoginInfo} from "@/views/examCenter/reportTax/reportTaxLoginHandler.js";

const emit = defineEmits('loginSuccess', 'goSuccess')

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
})

function exeLogin() {
  if (props.currentQa.queType == '2') { // 报税题
    setReportTaxLoginInfo()
  } else {
    setLoginInfo()
  }
  emit('loginSuccess')
}
</script>


<style scoped lang="scss">
.login-pane {
  height: 100%;
  overflow-y: auto;

  .header {
    background: linear-gradient(90deg, #418eff, #4391f1);
    height: 90px;
    padding: 0 40px;
    font-size: 16px;
    color: #FFFFFF;
    display: flex;
    align-items: center;


    .big {
      font-size: 26px;
      font-weight: 700;
      margin-right: 10px;
    }

    .tong {
      margin-left: 10px;
    }

    .grow {
      flex-grow: 1;
    }

    .bt {
      font-weight: 700;
      margin-right: 30px;
    }
  }

  .main-box {
    height: 690px;
    background-image: url("https://static.rhkj.com/renhe_fe/other/320.png");
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .pane {
      width: 851px;
      height: 572px;
      background-image: url("https://static.rhkj.com/renhe_fe/other/321.png");
      cursor: pointer;
    }
  }

  .foot {
    background-color: #202833;
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
